import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Covariate"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M6 13.5C6.82843 13.5 7.5 12.8284 7.5 12 7.5 11.1716 6.82843 10.5 6 10.5 5.17157 10.5 4.5 11.1716 4.5 12 4.5 12.8284 5.17157 13.5 6 13.5zM10.5 7.5C11.3284 7.5 12 6.82843 12 6 12 5.17157 11.3284 4.5 10.5 4.5 9.67157 4.5 9 5.17157 9 6 9 6.82843 9.67157 7.5 10.5 7.5zM21 10.5C21.8284 10.5 22.5 9.82843 22.5 9 22.5 8.17157 21.8284 7.5 21 7.5 20.1716 7.5 19.5 8.17157 19.5 9 19.5 9.82843 20.1716 10.5 21 10.5zM15.75 15C16.5784 15 17.25 14.3284 17.25 13.5 17.25 12.6716 16.5784 12 15.75 12 14.9216 12 14.25 12.6716 14.25 13.5 14.25 14.3284 14.9216 15 15.75 15z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 2.56058L21.4394 1.5L3 19.9394V1.5H1.5V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H22.5V21H4.06058L22.5 2.56058Z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Covariate.vue"]]);
